import React, { useEffect, useState } from 'react';

import { Input } from './Input';
import { InputCurrencyProps } from './Input.types';

export const localStringToNumber = (value: string) =>
  value.replace(',00', '').replace(/[^0-9.,]/g, '');

const InputCurrency = React.forwardRef<HTMLInputElement, InputCurrencyProps>(
  ({ value, onChange, onFocus, onBlur, ...props }, ref) => {
    const [currency, setCurrency] = useState('');
    useEffect(() => {
      if (
        !value ||
        (value && value.length === 0) ||
        Number.isNaN(parseFloat(value)) ||
        parseFloat(value) < 1
      ) {
        setCurrency('');
        return;
      }

      const numberWithoutStyle = localStringToNumber(value).replace(',', '.');

      const numberWithCheckedMax =
        parseFloat(numberWithoutStyle) > 1000000 ? 1000000 : value;

      const styledValue = Number(numberWithCheckedMax).toLocaleString('PL', {
        style: 'currency',
        currency: 'PLN',
        currencyDisplay: 'code',
      });
      setCurrency(styledValue);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function removeEnter(event: React.KeyboardEvent) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    }

    return (
      <Input
        onKeyDown={removeEnter}
        type="text"
        value={currency}
        inputMode="decimal"
        autoComplete="off"
        success={currency.includes('PLN')}
        onChange={(e) => {
          if (onChange) {
            const value = parseFloat(e.target.value.replace(',', '.'));
            const numberWithCheckedMaxAndMin =
              value < 1 ? 1 : value > 1000000 ? 1000000 : value;
            onChange(
              Number.isNaN(value) ? '' : numberWithCheckedMaxAndMin.toFixed(2)
            );
          }
          setCurrency((e.target as HTMLInputElement).value);
        }}
        onFocus={(e) => {
          const removeCurrencyStyle = localStringToNumber(e.target.value) ?? '';
          setCurrency(removeCurrencyStyle);
          onFocus && onFocus(e);
        }}
        onBlur={(e) => {
          const { value } = e.target;

          if (value === '') {
            return setCurrency('');
          }

          const numberWithCheckedMaxAndMin =
            parseFloat(value) < 1
              ? 1
              : parseFloat(value) > 1000000
                ? 1000000
                : parseFloat(value.replace(',', '.'));

          const isValidNumber = !Number.isNaN(parseFloat(value));

          if (isValidNumber) {
            const styledValue = Number(
              String(numberWithCheckedMaxAndMin).replace(',', '.')
            ).toLocaleString('PL', {
              style: 'currency',
              currency: 'PLN',
              currencyDisplay: 'code',
            });
            setCurrency(styledValue);
          }
          if (!isValidNumber) {
            setCurrency('');
          }

          onBlur && onBlur(e);
        }}
        ref={ref}
        data-testid={`${props.name}-input`}
        {...props}
      />
    );
  }
);

InputCurrency.displayName = 'InputCurrency';

export { InputCurrency };
